import staffFetch from "./staffFetch";
import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";

function StaffQuickRepliesPage() {
  const [replies, setReplies] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadReplies = async () => {
    try {
      setLoading(true);

      const res = await staffFetch(`${API}/staff/replies`);
      const data = await res.json();

      setReplies(data.replies || []);
    } catch (err) {
      console.log("Erreur quick replies:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReplies();
  }, []);

  return (
    <div
      style={{
        background: "#020b14",
        minHeight: "100vh",
        padding: 20,
        color: "#fff"
      }}
    >
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <h1
          style={{
            color: "#00f2ff",
            fontSize: 24,
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: 20
          }}
        >
          ⚡ Réponses rapides
        </h1>

        {loading ? (
          <div style={{ color: "#00f2ff", textAlign: "center" }}>
            Chargement...
          </div>
        ) : replies.length === 0 ? (
          <div
            style={{
              color: "#8fa6ad",
              textAlign: "center",
              marginTop: 30
            }}
          >
            Aucune réponse rapide.
          </div>
        ) : (
          replies.map((item) => (
            <div
              key={item.id}
              style={{
                background: "#061827",
                padding: 14,
                borderRadius: 10,
                marginBottom: 12,
                border: "1px solid #12344a"
              }}
            >
              <div
                style={{
                  color: "#00f2ff",
                  fontSize: 11,
                  fontWeight: "bold",
                  marginBottom: 6
                }}
              >
                {String(item.category || "support").toUpperCase()}
              </div>

              <div
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                  marginBottom: 6
                }}
              >
                {item.title}
              </div>

              <div
                style={{
                  color: "#8fa6ad",
                  fontSize: 13,
                  lineHeight: "19px",
                  whiteSpace: "pre-wrap"
                }}
              >
                {item.message}
              </div>
            </div>
          ))
        )}

        <button
          onClick={() => {
            window.location.href = "/staff";
          }}
          style={{
            background: "#007bff",
            padding: 12,
            borderRadius: 8,
            border: "none",
            color: "#fff",
            fontWeight: "bold",
            width: "100%",
            marginTop: 14,
            cursor: "pointer"
          }}
        >
          ← Retour Staff
        </button>
      </div>
    </div>
  );
}

export default StaffQuickRepliesPage;
